export enum ChatNotificationType {
  MessageReceived = 'chat.message.received',
  MessageUnread = 'chat.message.unread',
  MessageRead = 'chat.message.read',
  ThreadAssigned = 'chat.thread.assigned',
  ThreadUnassigned = 'chat.thread.unassigned',
}

export interface ChatNotificationPayload {
  id: string;
  type: ChatNotificationType;
  date: string;
  threadId: string;
  messageIds?: string;
  senderId?: string;
  assignees?: string[] | null;
  notification?: {
    title: string;
    body: string;
    icon?: string;
  };
  data?: Record<string, any>;
}

export interface NotificationConfig {
  enabled: boolean;
  soundEnabled: boolean;
  soundUrl?: string;
  maxVisibleNotifications: number;
  debounceMs: number;
  customIcon?: string;
  clickAction?: 'focus' | 'navigate' | 'custom';
}

export interface ChatNotificationHandler {
  type: ChatNotificationType;
  showSystemNotification: boolean;
  updateState: boolean;
  handler: (payload: ChatNotificationPayload) => void;
}

export enum NotificationPermissionStatus {
  Default = 'default',
  Granted = 'granted',
  Denied = 'denied',
}

export interface NotificationQueueItem {
  id: string;
  payload: ChatNotificationPayload;
  timestamp: Date;
  attempts: number;
  priority: number;
}
